import { Component } from '@angular/core';

@Component({
  selector: 'admin-inspired',
  imports: [],
  templateUrl: './inspired.html',
  styleUrl: './inspired.scss',
})
export class Inspired {

}
